import loadable from '@loadable/component';

import './NewSearch.css';

export default loadable(() => {
  return import('./NewSearch.jsx');
});
